import React from 'react';
import { VStack, Text, Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useSectionInView } from './WrappedSection';

const MotionBox = motion(Box);

const StorySection = ({ section, children, shouldReduceMotion = false }) => {
  const {
    description,
    label,
    accentColor,
    bgColor,
    textColor: customTextColor,
  } = section;
  const inView = useSectionInView();

  // Se non c'è descrizione, renderizzare solo i children
  if (!description) {
    return children;
  }

  // Determina il colore del testo in base al background
  const getTextColor = () => {
    if (accentColor) {
      // Se accentColor è white o contiene 'white', usa white
      if (
        accentColor === '#ffffff' ||
        accentColor === 'white' ||
        (typeof accentColor === 'string' && accentColor.includes('white'))
      ) {
        return 'white';
      }
      // Se accentColor è black, usa black
      if (
        accentColor === '#000000' ||
        accentColor === 'black' ||
        (typeof accentColor === 'string' && accentColor.includes('black'))
      ) {
        return 'black';
      }
    }
    // Default basato su bgColor
    if (
      bgColor === 'white' ||
      bgColor === 'brand.100' ||
      bgColor === '#ffcc00'
    ) {
      return 'gray.700';
    }
    // Se bgColor è un colore scuro, usa white
    if (
      bgColor &&
      (bgColor.includes('#3b235a') ||
        bgColor.includes('#1a202c') ||
        bgColor.includes('#3eb297') ||
        bgColor.includes('#36a9e1') ||
        bgColor.includes('#e95995'))
    ) {
      return 'white';
    }
    return 'gray.700';
  };

  const descriptionAnimation = shouldReduceMotion
    ? {}
    : {
        initial: { opacity: 0, y: 10 },
        animate: inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 10 },
        transition: { duration: 0.5, delay: 0.15, ease: 'easeOut' },
      };

  const textColor = customTextColor || getTextColor();

  const labelAnimation = shouldReduceMotion
    ? {}
    : {
        initial: { opacity: 0, y: 10 },
        animate: inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 10 },
        transition: { duration: 0.5, delay: 0.1, ease: 'easeOut' },
      };

  return (
    <VStack spacing={8} align="center" w="100%">
      {children}
      {label && (
        <MotionBox
          textAlign="center"
          initial={labelAnimation.initial}
          animate={labelAnimation.animate}
          transition={labelAnimation.transition}
        >
          <Text
            as="h2"
            fontSize={{ base: '2xl', md: '3xl', lg: '4xl' }}
            fontWeight="bold"
            color={textColor}
            letterSpacing="wide"
            textTransform="uppercase"
          >
            {label}
          </Text>
        </MotionBox>
      )}
      {description && (
        <MotionBox
          maxW={{ base: '100%', md: '900px', lg: '1000px' }}
          textAlign="center"
          px={{ base: 4, md: 6, lg: 8 }}
          initial={descriptionAnimation.initial}
          animate={descriptionAnimation.animate}
          transition={descriptionAnimation.transition}
        >
          <Text
            as="p"
            fontSize={{ base: 'xl', md: '2xl', lg: '3xl' }}
            fontWeight="normal"
            color={textColor}
            opacity={0.95}
            lineHeight="1.5"
          >
            {description}
          </Text>
        </MotionBox>
      )}
    </VStack>
  );
};

export default StorySection;
